<template>
    <section>
        <o-field>
            <o-switch size="small" label="Small" />
        </o-field>

        <o-field>
            <o-switch label="Default" />
        </o-field>

        <o-field>
            <o-switch size="medium" label="Medium" />
        </o-field>

        <o-field>
            <o-switch size="large" label="Large" />
        </o-field>
    </section>
</template>
